<template>
  <div>
<!--    <video src="@/imgValue/gsjs.mp4" class="videoBox" controls autoplay loop muted></video>-->
    <img src="@/image/imgData.png" alt="" class="imgData">
  </div>
</template>

<script>
export default {
  name: "companyIntroduction"
}
</script>

<style scoped>
.videoBox{
  width: 362px;
  height: 204px;
  display: block;
  margin: 14px auto;
  object-fit: contain;
}
.imgData{
  width: 100%;
  display: block;
}
</style>